import { ConfigurationState } from 'redux/reducers/initialState'

export type EnvConfigType = {
  apiUrl: string
  msal: {
    authority: string
    clientId: string
    scopes: string[]
  }
}

export type AcquireTokenOptionsType = {
  scopes: string[]
}

export type SigninOptionsType = {
  scopes: string[]
  prompt: string
}

export type MSALConfigType = {
  auth: {
    authority: string
    clientId: string
    redirectUri: string
  }
  cache: {
    cacheLocation: string
    storeAuthStateInCookie: boolean
  }
}

export function getMsalConfig(
  appConfiguration: ConfigurationState | null = null,
) {
  const msalConfig: MSALConfigType = {
    auth: {
      authority: appConfiguration?.msalAuthority || '',
      clientId: appConfiguration?.clientId || '',
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
  }
  return msalConfig
}

export function getAcquireTokenOptions(
  appConfiguration: ConfigurationState | null = null,
): AcquireTokenOptionsType {
  const acquireTokenOptions: AcquireTokenOptionsType = {
    scopes: appConfiguration?.msalScopes || [],
  }
  return acquireTokenOptions
}

export function getSignInOptions(
  appConfiguration: ConfigurationState | null = null,
): AcquireTokenOptionsType {
  const signInOptions: SigninOptionsType = {
    scopes: appConfiguration?.msalScopes || [],
    prompt: 'login',
  }

  return signInOptions
}

export function isConfigEmpty(
  appConfiguration: ConfigurationState | null = null,
): boolean {
  if (appConfiguration) {
    return (
      !appConfiguration.kmsApiUrl?.trim() ||
      !appConfiguration.msalAuthority?.trim() ||
      !appConfiguration.msalScopes ||
      appConfiguration.msalScopes.length === 0 ||
      !appConfiguration.clientId?.trim()
    )
  }
  return true
}
